import { post, get } from './api';

const FILE_TYPE_CONTRACT = 3;
const FILE_TYPE_OGRN = 4;
const FILE_TYPE_PASSPORT = 1;

export function downloadProfileContract({type, values}) {
    // @TODO hard id
    const types = {
        'html': 1,
        'pdf': 2,
        'doc': 4,
    };

    const form = document.createElement('form');
    form.style.display = 'none';
    form.method = 'POST';
    form.action = `/api/v1/file/generateAgreement?fileFormat=${types[type]}`;

    Object.keys(values).map((field) => {
        const el = document.createElement('input');

        el.value = values[field];
        el.name = field;
        form.appendChild(el);
    });

    document.body.appendChild(form);

    form.submit();
}

function genFormatData(files) {
    const formData = new FormData();

    files.map((file, index) => {
        formData.append(`file${index + 1}`, file);
    });

    return formData;
}

function toQueryString(query) {
    return Object.keys(query).reduce((queryString, param) => {
        return queryString += [param, query[param]].join('=');
    }, '');
}

export function uploadFile(files, query) {
    return post(
        'file/upload?' + toQueryString(query),
        genFormatData(files),
        {
            dataType: undefined
        }
    )
        .then((res) => {
            return Promise.resolve({
                ...res,
                data: res.data.map((file, index) => ({
                    ...file,
                    name: file.originalName,
                })),
            });
        })
        .catch((res) => {
            switch (res.status) {
                case 400:
                    return Promise.reject({
                        ...res,
                        message: res.data.message,
                    });
                default:
                    return Promise.reject(res);
            }
        });
}

export function uploadContractFile(files) {
    return uploadFile(files, { fileType: FILE_TYPE_CONTRACT });
}

export function uploadOgrnFile(files) {
    return uploadFile(files, { fileType: FILE_TYPE_OGRN });
}

export function uploadPassportScans(files) {
    return uploadFile(files, { fileType: FILE_TYPE_PASSPORT });
}

function downloadFile(link) {
    get(link)
        .then((res) => {
            window.location.href = '/userfiles/' + res.data;
        })
        .catch(() => {
            window.location.reload();
        });
}

export function downloadContractLink() {
    downloadFile('file/contractLink');
}

export function downloadAdditionalContractLink(tariffId) {
    downloadFile(`file/additionalContractLink?id=${tariffId}`);
}

export function fetchContractLink() {
    return get('file/contractLink');
}

export function fetchAdditionalContractLink(tariffId) {
    return get(`file/additionalContractLink?id=${tariffId}`);
}



// WEBPACK FOOTER //
// ./src/services/api/file.js